import * as React from "react";
import DashboardLayout from "../../Layout/DashboardLayout";
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AddIcon from "@mui/icons-material/Add";
import TextField from '@mui/material/TextField';
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router";
import { GetCaseStudy, UpdateCaseStudy } from "../../services/projects.handlers";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Checkbox from '@mui/material/Checkbox';
import { Link } from "react-router-dom";

const TableRowData = [
  "ID",
  "Home",
  "Vertical",
  "Title",
  "Action",
  "Preview"
];

const Projects = () => {
  const [allData, setAllData] = React.useState({
    caseStudyList: [],
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
  });
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const navigate = useNavigate();

  React.useEffect(() => {
    fetchData();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const fetchData = () => {
    GetCaseStudy({
      page: 1,
      limit: 1000,
    }).then(response => {
      if (response.status) {
        setAllData(response.data.data);
      }
    })
  }

  function handleShowHome(id, val) {
    const payload = {
      _id: id,
      isHome: val
    }
    UpdateCaseStudy(payload).then(response => {
      if (response.status) {
        alert(response.message)
        fetchData()
      }
    })
  }

  function handlePublish(id, val) {
    const payload = {
      _id: id,
      isActive: !val
    }
    UpdateCaseStudy(payload).then(response => {
      if (response.status) {
        alert(response.message)
        fetchData()
      }
    })
  }

  return (
    <DashboardLayout>
      <Stack spacing={2} direction="row" style={{ marginBottom: "30px", justifyContent: "flex-end" }}>
        <Button
          onClick={() => navigate("/add_projects")}
          variant="contained"
        >
          <AddIcon /> Add Projects
        </Button>
      </Stack>
      <TableContainer>
        <Table
          sx={{ minWidth: 750 }}
          aria-labelledby="tableTitle"
          size={"medium"}
        >
          <TableHead>
            <TableRow>
              {TableRowData.map((item, index) => (
                <TableCell key={index}>
                  {item}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {allData.caseStudyList.length > 0 ? (
              allData.caseStudyList
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((item, index) => {
                  return (
                    <TableRow hover tabIndex={-1} key={index}>
                      <TableCell>
                        {page * 10 + index + 1}
                      </TableCell>
                      <TableCell>
                        <Checkbox
                          checked={item.isHome ? true : false}
                          onChange={(e) => handleShowHome(item._id, e.target.checked)}
                        />
                      </TableCell>
                      <TableCell
                        component="td"
                        // id={labelId}
                        scope="row"
                      >
                        {item.projectType.map(item => item.project_type)}
                      </TableCell>
                      <TableCell
                        component="td"
                        // id={labelId}
                        scope="row"
                      >
                        {item.title}
                      </TableCell>

                      <TableCell
                        component="td"
                        // id={labelId}
                        scope="row"
                      >
                        <Button variant="contained" style={{ background: "green", marginRight: "5px" }} onClick={() => navigate(`/edit_projects/${item._id}`)}>Edit</Button>
                        {
                          item.isActive ?
                            <Button variant="contained" style={{ background: "red" }} onClick={() => handlePublish(item._id, item.isActive)}>UnPublish</Button>
                            :
                            <Button variant="contained" style={{ background: "green" }} onClick={() => handlePublish(item._id, item.isActive)}>Publish</Button>

                        }
                      </TableCell>
                      <TableCell
                        component="td"
                        // id={labelId}
                        scope="row"
                      >
                        <Link target="_blank" to={{
                          pathname: "/preview/" + item._id,
                        }}>Detail</Link>


                      </TableCell>
                    </TableRow>
                  );
                })
            ) : (
              <TableRow
                hover
                //   onClick={(event) => handleClick(event, row.name)}
                role="checkbox"
                //   aria-checked={isItemSelected}
                tabIndex={-1}
              >
                <TableCell
                  style={{ width: "100%" }}
                  component="td"
                  colSpan={6}
                  align={"center"}
                  // id={labelId}
                  scope="row"
                // padding="checkbox"
                >
                  No Records Available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={allData.caseStudyList.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </DashboardLayout>
  );
};

export default Projects;
